<app-main-header [name_main]="'Tableros'">
    <app-user-card></app-user-card>
</app-main-header>

@if(dashBoards$ | async; as allDash){
@if(allDash.length === 0){
<div style="display: grid; place-items: center;">
    <p>No hay tableros asignados al usuario</p>
</div>
} @else {

@if(user$ | async; as d){
@if(filteredDashboards$ | async; as dash){

<div class="boards-toolbar">
    <div class="toolbar-filters">
        <mat-form-field class="search-field" appearance="outline">
            <mat-label>Buscar tablero</mat-label>
            <input matInput type="text" placeholder="Nombre del tablero" #searchInput (input)="onSearchChange($event)">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field class="clients" appearance="outline" *ngIf="d.roles?.admin">
            <mat-label>Filtrar por Cliente</mat-label>
            <mat-select (selectionChange)="onClientChange($event.value)" [value]="selectedClientValue">
                <mat-option value="all">Todos</mat-option>
                @for(client of clients$ | async; track client.id) {
                <mat-option [value]="client.id.toString()">{{ client.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        @if (hasActiveFilters()) {
        <button mat-icon-button type="button" class="clear-filters-btn" matTooltip="Limpiar filtros" (click)="clearFilters()">
            <mat-icon>close</mat-icon>
        </button>
        }
    </div>

    @if (dash.length > 0) {
    <p class="results-count">{{ dash.length }} tablero{{ dash.length === 1 ? '' : 's' }} encontrado{{ dash.length === 1 ? '' : 's' }}</p>
    }
</div>

@if(dash.length === 0){
<div class="no-results">
    <p>{{ hasActiveFilters() ? 'No se encontraron tableros con esos filtros.' : 'No hay tableros asignados al usuario' }}</p>
    @if (hasActiveFilters()) {
    <button mat-stroked-button type="button" (click)="clearFilters()">Limpiar filtros</button>
    }
</div>
} @else {
<div class="ctn-card-bi">
    @for (item of dash; track $index) {
    <div class="card-bi"
        role="button"
        tabindex="0"
        (click)="onCardClick(item, d)"
        (keydown.enter)="onCardClick(item, d)"
        (keydown.space)="$event.preventDefault(); onCardClick(item, d)">
        <div class="card-accent" [ngStyle]="{'background-color': getBackgroundColor($index)}"></div>
        <div class="card-banner">
            @if (item.url_image) {
            <img [src]="item.url_image" alt="" class="card-logo">
            } @else {
            <mat-icon class="card-fallback-icon" [ngStyle]="{'color': getBackgroundColor($index)}">bar_chart</mat-icon>
            }
        </div>
        <div class="body-card-bi">
            <h4 class="title-bi">{{item.name}}</h4>
            <span class="btn-bi" aria-hidden="true">
                <span class="btn-bi-label">Ver tablero</span>
                <mat-icon class="btn-bi-icon">arrow_forward</mat-icon>
            </span>
        </div>
    </div>
    }
</div>
}

}
}
}
}@else{
<div style="display: grid; place-items: center;">
    <p>No hay tableros asignados al usuario</p>
</div>
}

